import { Observable } from 'rxjs';

import { useBackendHttpService } from '../../http';
import { ReportType } from '../domain';

const API = '/s/billing-metrics/v1';

type BillingReportDto = {
	startYearMonth: string;
	endYearMonth: string;
	reportTypes: ReportType[];
};

export function generateBillingReport(startYearMonth: string, endYearMonth: string, reportTypes: ReportType[]): Observable<Blob> {
	const { http } = useBackendHttpService();

	const payload: BillingReportDto = {
		startYearMonth,
		endYearMonth,
		reportTypes
	};

	return http.post(`${API}/reports`, payload, {
		responseType: 'arraybuffer'
	});
}
